<style>
  .multiselect.is-invalid .multiselect__tags {
    border-color: red !important;
  }
</style>
<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { format } from 'date-fns';
import { getFirebaseBackend } from '@/helpers/firebase/authUtils';
// import Multiselect from "vue-multiselect";
import Swal from 'sweetalert2';
import {
  required,
  helpers,
  // email,
  // minLength,
  // sameAs,
  // maxLength,
  // minValue,
  // maxValue,
  // numeric,
  // url,
  // alphaNum
} from "vuelidate/lib/validators";
const phone_val = helpers.regex(
  "phone_val",
  /^[0-9]{3}-[0-9]{7,11}$/
)
export default {
    page: {
        title: "Pengguna",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
          title: "Biodata",
          fullname: this.$store.state.auth.currentUser.displayName,
          phone_no: "",
          sekolah_ppd: "",
          sektor: null,
          items: [
            {
              text: "Home",
              href: "/"
            },
            {
              text: "Biodata",
              active: true
            }
            ]
        };
    },
    validations: {
      fullname: { required },
      phone_no: { required, phone_val },
      sekolah_ppd: { required },
      sektor: { required },
        // slot_pilih: { required }
    },
    watch: {
        // pkg_pilih:function() {
        //     this.senaraiBilik()
        //     this.bilik_pilih = []
        //     const nama_pkg = collect(this.pkg).filter((value) => value.id == this.pkg_pilih).all()
        //     this.nama_pkg = nama_pkg[0]['nama']
        // },
        // hariIniStr:function() {
        //     this.senaraiBilik()
        //     this.bilik_pilih = []
        // },
        // bilik_pilih:function() {
        //     this.semakSlot()
        //     const url_bilik = collect(this.pkg).filter((value) => value.id == this.pkg_pilih).all()
        //     const bilik_satu = collect(url_bilik[0]['bilik']).filter((value) => value.nama == this.bilik_pilih).all()
        //     if (bilik_satu.length>0){
        //       this.bilik_url = bilik_satu[0]['url']
        //     }
            
        // }
    },
    methods: {
      kemaskiniBio() {
        this.$v.fullname.$touch();
        this.$v.phone_no.$touch();
        this.$v.sekolah_ppd.$touch();
        this.$v.sektor.$touch();

        if (this.$v.fullname.$error || this.$v.phone_no.$error || this.$v.sekolah_ppd.$error || this.$v.sektor.$error) {
            console.log('This value is required.')
          }
        else {
          const usr_infos = {
            fullname: this.fullname,
            phone_no: this.phone_no,
            sekolah_ppd: this.sekolah_ppd,
            sektor: this.sektor
          }
          getFirebaseBackend().upsertUsers(usr_infos).then(() => {
            Swal.fire("Kemaskini berjaya!");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Kemaskini tidak berjaya!",
              footer: error
            });
          });
        }
      }
  },
  mounted() {
    // this.senaraiPKG()
    if (sessionStorage.getItem('user_detail')) {
      const user = JSON.parse(sessionStorage.getItem('user_detail'))
      if (user) {
        console.log("getDetailUser",user) 
        this.fullname = user.fullname
        this.phone_no = user.phone_no
        this.sekolah_ppd = user.sekolah_ppd
        this.sektor = user.sektor
      }
    }
    console.log("user:",this.$store.state.auth.currentUser)
    // this.senaraiTempahan(this.hariIniStr.replace(/-/g,'/'))
  }
}
</script>
<!-- 1. Nama Pemohon
2. No Telefon
3. Sekolah/PPD/JPWPKL
4. Tajuk Program/Mesyuarat/Bengkel/Aktiviti
5. Bil. Peserta -->
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <form class="form-horizontal" role="form">
            <b-form-group
              id="fullname"
              label-cols-sm="2"
              label-cols-lg="2"
              label="Nama Penuh"
              label-for="fullname"
              >
              <b-form-input for="fullname" placeholder="Artisanal kale" :class="{ 'is-invalid': $v.fullname.$error }" v-model="fullname"></b-form-input>
              <div v-if="$v.fullname.$error" class="invalid-feedback">
                <span v-if="!$v.fullname.required">This value is required.</span>
              </div>
            </b-form-group>
            <b-form-group
              id="phone_no"
              label-cols-sm="2"
              label-cols-lg="2"
              label="No Telefon"
              label-for="phone_no"
              >
              <b-form-input for="phone_no" type="tel" placeholder="019-4996778" :class="{ 'is-invalid': $v.phone_no.$error }" v-model="phone_no"></b-form-input>
              <div v-if="$v.phone_no.$error" class="invalid-feedback">
                <span v-if="!$v.phone_no.required">This value is required.</span>
                <span v-if="!$v.phone_no.phone_val">This value not follow format.</span>
              </div>
            </b-form-group>
            <b-form-group
              id="sekolah_ppd"
              label-cols-sm="2"
              label-cols-lg="2"
              label="Sekolah/PPD/JPWPKL"
              label-for="sekolah_ppd"
              >
              <b-form-input for="sekolah_ppd" placeholder="PKG Bangsar" :class="{ 'is-invalid': $v.sekolah_ppd.$error }" v-model="sekolah_ppd"></b-form-input>
              <div v-if="$v.sekolah_ppd.$error" class="invalid-feedback">
                <span v-if="!$v.sekolah_ppd.required">This value is required.</span>
              </div>
            </b-form-group>
            <b-form-group
              id="sektor"
              label-cols-sm="2"
              label-cols-lg="2"
              label="Unit/Sektor"
              label-for="sektor"
              >
              <b-form-input for="sektor" placeholder="Masukkan Sektor" :class="{ 'is-invalid': $v.sektor.$error }" v-model="sektor"></b-form-input>
              <div v-if="$v.sektor.$error" class="invalid-feedback">
                <span v-if="!$v.sektor.required">This value is required.</span>
              </div>
            </b-form-group>
            <b-form-group>
              <button type="button" class="btn btn-primary btn-sm"  @click="kemaskiniBio">Kemaskini</button>
            </b-form-group>
            
        </form>
      </div>
    </div>
  </Layout>
</template>